import React from "react";
import { Card, CardBody, Col, Row } from "react-bootstrap";

const Cards = () => {
  return (
    <>
      <Row>
        <Col md={4} sm={12} className="mt-3">
          <Card className="border-0">
            <CardBody>
              <h6 className="text-blend">Candidate Pool</h6>
              <h5>500</h5>
              <img className="img-fluid" src="/images/vectors/candidate.png" />
            </CardBody>
          </Card>
        </Col>

        <Col md={4} sm={12} className="mt-3">
          <Card className="border-0">
            <CardBody>
              <h6 className="text-blend">Applicants</h6>
              <h5>400</h5>
              <img className="img-fluid" src="/images/vectors/applicants.png" />
            </CardBody>
          </Card>
        </Col>

        <Col md={4} sm={12} className="mt-3">
          <Card className="border-0">
            <CardBody>
              <h6 className="text-blend">Hired Candidate</h6>
              <h5>500</h5>
              <img className="img-fluid" src="/images/vectors/hired.png" />
            </CardBody>
          </Card>
        </Col>

        <Col md={4} sm={12} className="mt-3">
          <Card className="border-0">
            <CardBody>
              <h6 className="text-blend">Total Jobs</h6>
              <h5>500</h5>
              <img className="img-fluid" src="/images/vectors/jobs.png" />
            </CardBody>
          </Card>
        </Col>

        <Col md={4} sm={12} className="mt-3">
          <Card className="border-0">
            <CardBody>
              <h6 className="text-blend">Open Jobs</h6>
              <h5>400</h5>
              <img className="img-fluid" src="/images/vectors/open.png" />
            </CardBody>
          </Card>
        </Col>

        <Col md={4} sm={12} className="mt-3">
          <Card className="border-0">
            <CardBody>
              <h6 className="text-blend">Closed Jobs</h6>
              <h5>500</h5>
              <img className="img-fluid" src="/images/vectors/close.png" />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Cards;
